const TAB_LABELS = {
  'customer-search': 'Müşteri Arama',
  'customer-create': 'Müşteri Oluştur',
  'gorusme-hub': 'Santral (S)',
  'operation-select': 'İşlem Seç',
  'product-select': 'Ürün Seç',
  'checklist-questions': 'Kontrol Listesi',
  'device-select': 'Cihaz Seç',
  'fault-select': 'Arıza Seç',
  'address-select': 'Adres Seç',
  'tech-service-select': 'Teknik Servis Seç',
  'complaint-category-select': 'Kategori Seç',
  'complaint-product-select': 'Ürün Seç',
  'complaint-tech-service-select': 'Teknik Servis',
  'complaint-note': 'Not',
  finish: 'Bitir',
};

export function getSantralTabLabel(tabKey) {
  if (!tabKey) return 'Servis kaydı';
  return TAB_LABELS[tabKey] || tabKey;
}
